export const totalsData = {
  UTAH: [
    {
      x: 'Week 1',
      y: 197.1,
      team: 'UTAH',
    },
    {
      x: 'Week 2',
      y: 197.775,
      team: 'UTAH',
    },
    {
      x: 'Week 3',
      y: 197.4,
      team: 'UTAH',
    },
    {
      x: 'Week 4',
      y: 197.675,
      team: 'UTAH',
    },
    {
      x: 'Week 5',
      y: 197.75,
      team: 'UTAH',
    },
    {
      x: 'Week 6',
      y: 197.275,
      team: 'UTAH',
    },
    {
      x: 'Week 7',
      y: 198,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 197.95,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 196.775,
      team: 'UTAH',
    },
    {
      x: 'Week 9',
      y: 198.575,
      team: 'UTAH',
    },
    {
      x: 'Week 10',
      y: 197.875,
      team: 'UTAH',
    },
  ],
  CAL: [
    {
      x: 'Week 2',
      y: 196.325,
      team: 'CAL',
    },
    {
      x: 'Week 3',
      y: 196.675,
      team: 'CAL',
    },
    {
      x: 'Week 4',
      y: 197.35,
      team: 'CAL',
    },
    {
      x: 'Week 5',
      y: 196.925,
      team: 'CAL',
    },
    {
      x: 'Week 6',
      y: 197.525,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 197.575,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 196.85,
      team: 'CAL',
    },
    {
      x: 'Week 9',
      y: 197.2,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 196.875,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 197.9,
      team: 'CAL',
    },
  ],

  'OREGON STATE': [
    {
      x: 'Week 2',
      y: 195.55,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 3',
      y: 197,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 4',
      y: 196.575,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 5',
      y: 197.375,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 6',
      y: 197.275,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 7',
      y: 197.15,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 8',
      y: 197.225,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 9',
      y: 196.675,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 10',
      y: 196.875,
      team: 'OREGON STATE',
    },
  ],
  WASHINGTON: [
    { x: 'Week 2', y: 194, team: 'WASHINGTON' },
    { x: 'Week 3', y: 195.45, team: 'WASHINGTON' },
    { x: 'Week 4', y: 195.1, team: 'WASHINGTON' },
    { x: 'Week 5', y: 196.25, team: 'WASHINGTON' },
    { x: 'Week 6', y: 194.45, team: 'WASHINGTON' },
    { x: 'Week 7', y: 196.825, team: 'WASHINGTON' },
    { x: 'Week 8', y: 197.275, team: 'WASHINGTON' },
    { x: 'Week 8', y: 194.3, team: 'WASHINGTON' },
    { x: 'Week 9', y: 195.8, team: 'WASHINGTON' },
    { x: 'Week 9', y: 196.825, team: 'WASHINGTON' },
    { x: 'Week 10', y: 196.9, team: 'WASHINGTON' },
  ],
  ARIZONA: [
    { x: 'Week 2', y: 195.5, team: 'ARIZONA' },
    { x: 'Week 3', y: 193.775, team: 'ARIZONA' },
    { x: 'Week 4', y: 195.125, team: 'ARIZONA' },
    { x: 'Week 5', y: 196.05, team: 'ARIZONA' },
    { x: 'Week 6', y: 196.4, team: 'ARIZONA' },
    { x: 'Week 8', y: 196.025, team: 'ARIZONA' },
    { x: 'Week 8', y: 196.85, team: 'ARIZONA' },
    { x: 'Week 9', y: 195.925, team: 'ARIZONA' },
    { x: 'Week 10', y: 196.375, team: 'ARIZONA' },
    { x: 'Week 10', y: 196.3, team: 'ARIZONA' },
  ],
  'ARIZONA STATE': [
    {
      x: 'Week 2',
      y: 196.275,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 3',
      y: 196.1,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 4',
      y: 195.275,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 5',
      y: 196.55,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 6',
      y: 196.6,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 7',
      y: 197.8,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 8',
      y: 197.075,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 9',
      y: 197.375,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 10',
      y: 196.8,
      team: 'ARIZONA STATE',
    },
  ],

  UCLA: [
    { x: 'Week 3', y: 194.85, team: 'UCLA' },
    { x: 'Week 3', y: 196.3, team: 'UCLA' },
    { x: 'Week 4', y: 196.4, team: 'UCLA' },
    { x: 'Week 5', y: 197.65, team: 'UCLA' },
    { x: 'Week 6', y: 196.85, team: 'UCLA' },
    { x: 'Week 7', y: 195.475, team: 'UCLA' },
    { x: 'Week 8', y: 197.125, team: 'UCLA' },
    { x: 'Week 9', y: 198.05, team: 'UCLA' },
    { x: 'Week 10', y: 197.7, team: 'UCLA' },
  ],

  STANFORD: [
    { x: 'Week 2', y: 196.275, team: 'STANFORD' },
    { x: 'Week 3', y: 195.725, team: 'STANFORD' },
    { x: 'Week 4', y: 196, team: 'STANFORD' },
    { x: 'Week 5', y: 196.25, team: 'STANFORD' },
    { x: 'Week 6', y: 196.9, team: 'STANFORD' },
    { x: 'Week 7', y: 195.45, team: 'STANFORD' },
    { x: 'Week 8', y: 196.575, team: 'STANFORD' },
    { x: 'Week 8', y: 195.05, team: 'STANFORD' },
    { x: 'Week 9', y: 196.975, team: 'STANFORD' },
    { x: 'Week 9', y: 196.325, team: 'STANFORD' },
  ],
};

export const vaultData = {
  UTAH: [
    {
      x: 'Week 1',
      y: 49.325,
      team: 'UTAH',
    },
    {
      x: 'Week 2',
      y: 49.45,
      team: 'UTAH',
    },
    {
      x: 'Week 3',
      y: 49.275,
      team: 'UTAH',
    },
    {
      x: 'Week 4',
      y: 49.125,
      team: 'UTAH',
    },
    {
      x: 'Week 5',
      y: 49.55,
      team: 'UTAH',
    },
    {
      x: 'Week 6',
      y: 49.375,
      team: 'UTAH',
    },
    {
      x: 'Week 7',
      y: 49.225,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 49.4,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 49.3,
      team: 'UTAH',
    },
    {
      x: 'Week 9',
      y: 49.375,
      team: 'UTAH',
    },
    {
      x: 'Week 10',
      y: 49.4,
      team: 'UTAH',
    },
  ],
  CAL: [
    {
      x: 'Week 2',
      y: 49.175,
      team: 'CAL',
    },
    {
      x: 'Week 3',
      y: 49.075,
      team: 'CAL',
    },
    {
      x: 'Week 4',
      y: 49.175,
      team: 'CAL',
    },
    {
      x: 'Week 5',
      y: 49,
      team: 'CAL',
    },
    {
      x: 'Week 6',
      y: 49.35,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 49.3,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 49.175,
      team: 'CAL',
    },
    {
      x: 'Week 9',
      y: 49.25,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 49.2,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 49.225,
      team: 'CAL',
    },
  ],

  'OREGON STATE': [
    {
      x: 'Week 2',
      y: 49,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 3',
      y: 49.175,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 4',
      y: 49.35,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 5',
      y: 49.35,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 6',
      y: 49.175,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 7',
      y: 49.325,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 8',
      y: 49.15,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 9',
      y: 49.175,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 10',
      y: 49.3,
      team: 'OREGON STATE',
    },
  ],
  WASHINGTON: [
    { x: 'Week 2', y: 48.875, team: 'WASHINGTON' },
    { x: 'Week 3', y: 48.925, team: 'WASHINGTON' },
    { x: 'Week 4', y: 48.9, team: 'WASHINGTON' },
    { x: 'Week 5', y: 49.125, team: 'WASHINGTON' },
    { x: 'Week 6', y: 49.1, team: 'WASHINGTON' },
    { x: 'Week 7', y: 49.275, team: 'WASHINGTON' },
    { x: 'Week 8', y: 49.325, team: 'WASHINGTON' },
    { x: 'Week 8', y: 49.125, team: 'WASHINGTON' },
    { x: 'Week 9', y: 49.1, team: 'WASHINGTON' },
    { x: 'Week 9', y: 49.125, team: 'WASHINGTON' },
    { x: 'Week 10', y: 49.1, team: 'WASHINGTON' },
  ],
  ARIZONA: [
    { x: 'Week 2', y: 48.925, team: 'ARIZONA' },
    { x: 'Week 3', y: 48.65, team: 'ARIZONA' },
    { x: 'Week 4', y: 48.75, team: 'ARIZONA' },
    { x: 'Week 5', y: 48.75, team: 'ARIZONA' },
    { x: 'Week 6', y: 48.875, team: 'ARIZONA' },
    { x: 'Week 8', y: 48.875, team: 'ARIZONA' },
    { x: 'Week 8', y: 49.075, team: 'ARIZONA' },
    { x: 'Week 9', y: 49.025, team: 'ARIZONA' },
    { x: 'Week 10', y: 49.05, team: 'ARIZONA' },
    { x: 'Week 10', y: 48.925, team: 'ARIZONA' },
  ],
  'ARIZONA STATE': [
    {
      x: 'Week 2',
      y: 49.075,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 3',
      y: 49.175,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 4',
      y: 48.85,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 5',
      y: 49.25,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 6',
      y: 49.275,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 7',
      y: 49.3,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 8',
      y: 49.35,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 9',
      y: 49.3,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 10',
      y: 49.175,
      team: 'ARIZONA STATE',
    },
  ],

  UCLA: [
    { x: 'Week 3', y: 48.5, team: 'UCLA' },
    { x: 'Week 3', y: 48.85, team: 'UCLA' },
    { x: 'Week 4', y: 49.25, team: 'UCLA' },
    { x: 'Week 5', y: 49.275, team: 'UCLA' },
    { x: 'Week 6', y: 49.15, team: 'UCLA' },
    { x: 'Week 7', y: 49.325, team: 'UCLA' },
    { x: 'Week 8', y: 49.25, team: 'UCLA' },
    { x: 'Week 9', y: 49.475, team: 'UCLA' },
    { x: 'Week 10', y: 49.425, team: 'UCLA' },
  ],

  STANFORD: [
    { x: 'Week 2', y: 48.8, team: 'STANFORD' },
    { x: 'Week 3', y: 48.8, team: 'STANFORD' },
    { x: 'Week 4', y: 48.875, team: 'STANFORD' },
    { x: 'Week 5', y: 48.875, team: 'STANFORD' },
    { x: 'Week 6', y: 48.975, team: 'STANFORD' },
    { x: 'Week 7', y: 48.675, team: 'STANFORD' },
    { x: 'Week 8', y: 49.2, team: 'STANFORD' },
    { x: 'Week 8', y: 49, team: 'STANFORD' },
    { x: 'Week 9', y: 49.2, team: 'STANFORD' },
    { x: 'Week 9', y: 49, team: 'STANFORD' },
  ],
};

export const barsData = {
  UTAH: [
    {
      x: 'Week 1',
      y: 49.225,
      team: 'UTAH',
    },
    {
      x: 'Week 2',
      y: 49.35,
      team: 'UTAH',
    },
    {
      x: 'Week 3',
      y: 49.425,
      team: 'UTAH',
    },
    {
      x: 'Week 4',
      y: 49.4,
      team: 'UTAH',
    },
    {
      x: 'Week 5',
      y: 49.55,
      team: 'UTAH',
    },
    {
      x: 'Week 6',
      y: 49.3,
      team: 'UTAH',
    },
    {
      x: 'Week 7',
      y: 49.5,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 49.35,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 49.35,
      team: 'UTAH',
    },
    {
      x: 'Week 9',
      y: 49.8,
      team: 'UTAH',
    },
    {
      x: 'Week 10',
      y: 49.4,
      team: 'UTAH',
    },
  ],
  CAL: [
    {
      x: 'Week 2',
      y: 49.3,
      team: 'CAL',
    },
    {
      x: 'Week 3',
      y: 49.375,
      team: 'CAL',
    },
    {
      x: 'Week 4',
      y: 49.475,
      team: 'CAL',
    },
    {
      x: 'Week 5',
      y: 49.375,
      team: 'CAL',
    },
    {
      x: 'Week 6',
      y: 49.45,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 49.45,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 49.325,
      team: 'CAL',
    },
    {
      x: 'Week 9',
      y: 49.35,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 48.925,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 49.625,
      team: 'CAL',
    },
  ],

  'OREGON STATE': [
    {
      x: 'Week 2',
      y: 48.175,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 3',
      y: 49,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 4',
      y: 49.2,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 5',
      y: 49.275,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 6',
      y: 49.175,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 7',
      y: 49,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 8',
      y: 49.075,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 9',
      y: 49.15,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 10',
      y: 49.025,
      team: 'OREGON STATE',
    },
  ],
  WASHINGTON: [
    { x: 'Week 2', y: 48.825, team: 'WASHINGTON' },
    { x: 'Week 3', y: 48.8, team: 'WASHINGTON' },
    { x: 'Week 4', y: 48.875, team: 'WASHINGTON' },
    { x: 'Week 5', y: 48.85, team: 'WASHINGTON' },
    { x: 'Week 6', y: 49.075, team: 'WASHINGTON' },
    { x: 'Week 7', y: 49.15, team: 'WASHINGTON' },
    { x: 'Week 8', y: 49.325, team: 'WASHINGTON' },
    { x: 'Week 8', y: 47.725, team: 'WASHINGTON' },
    { x: 'Week 9', y: 48.475, team: 'WASHINGTON' },
    { x: 'Week 9', y: 49.175, team: 'WASHINGTON' },
    { x: 'Week 10', y: 49.1, team: 'WASHINGTON' },
  ],
  ARIZONA: [
    { x: 'Week 2', y: 49.05, team: 'ARIZONA' },
    { x: 'Week 3', y: 47, team: 'ARIZONA' },
    { x: 'Week 4', y: 48.825, team: 'ARIZONA' },
    { x: 'Week 5', y: 49.025, team: 'ARIZONA' },
    { x: 'Week 6', y: 49, team: 'ARIZONA' },
    { x: 'Week 8', y: 48.8, team: 'ARIZONA' },
    { x: 'Week 8', y: 49.2, team: 'ARIZONA' },
    { x: 'Week 9', y: 48.475, team: 'ARIZONA' },
    { x: 'Week 10', y: 49.1, team: 'ARIZONA' },
    { x: 'Week 10', y: 49.1, team: 'ARIZONA' },
  ],
  'ARIZONA STATE': [
    {
      x: 'Week 2',
      y: 49.225,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 3',
      y: 49.225,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 4',
      y: 48.425,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 5',
      y: 49.175,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 6',
      y: 49.2,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 7',
      y: 49.525,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 8',
      y: 49.225,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 9',
      y: 49.25,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 10',
      y: 49.425,
      team: 'ARIZONA STATE',
    },
  ],

  UCLA: [
    { x: 'Week 3', y: 48.3, team: 'UCLA' },
    { x: 'Week 3', y: 49.175, team: 'UCLA' },
    { x: 'Week 4', y: 49.05, team: 'UCLA' },
    { x: 'Week 5', y: 49.45, team: 'UCLA' },
    { x: 'Week 6', y: 49.35, team: 'UCLA' },
    { x: 'Week 7', y: 47.825, team: 'UCLA' },
    { x: 'Week 8', y: 49.175, team: 'UCLA' },
    { x: 'Week 9', y: 49.175, team: 'UCLA' },
    { x: 'Week 10', y: 49.475, team: 'UCLA' },
  ],

  STANFORD: [
    { x: 'Week 2', y: 49.125, team: 'STANFORD' },
    { x: 'Week 3', y: 49, team: 'STANFORD' },
    { x: 'Week 4', y: 49.025, team: 'STANFORD' },
    { x: 'Week 5', y: 48.975, team: 'STANFORD' },
    { x: 'Week 6', y: 49.45, team: 'STANFORD' },
    { x: 'Week 7', y: 48.975, team: 'STANFORD' },
    { x: 'Week 8', y: 48.65, team: 'STANFORD' },
    { x: 'Week 8', y: 49.125, team: 'STANFORD' },
    { x: 'Week 9', y: 49.125, team: 'STANFORD' },
    { x: 'Week 9', y: 49.1, team: 'STANFORD' },
  ],
};

export const beamData = {
  UTAH: [
    {
      x: 'Week 1',
      y: 49.375,
      team: 'UTAH',
    },
    {
      x: 'Week 2',
      y: 49.475,
      team: 'UTAH',
    },
    {
      x: 'Week 3',
      y: 49.025,
      team: 'UTAH',
    },
    {
      x: 'Week 4',
      y: 49.725,
      team: 'UTAH',
    },
    {
      x: 'Week 5',
      y: 49.05,
      team: 'UTAH',
    },
    {
      x: 'Week 6',
      y: 49.075,
      team: 'UTAH',
    },
    {
      x: 'Week 7',
      y: 49.725,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 49.6,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 48.725,
      team: 'UTAH',
    },
    {
      x: 'Week 9',
      y: 49.725,
      team: 'UTAH',
    },
    {
      x: 'Week 10',
      y: 49.675,
      team: 'UTAH',
    },
  ],
  CAL: [
    {
      x: 'Week 2',
      y: 48.625,
      team: 'CAL',
    },
    {
      x: 'Week 3',
      y: 49.1,
      team: 'CAL',
    },
    {
      x: 'Week 4',
      y: 49.3,
      team: 'CAL',
    },
    {
      x: 'Week 5',
      y: 49.35,
      team: 'CAL',
    },
    {
      x: 'Week 6',
      y: 49.25,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 49.475,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 48.925,
      team: 'CAL',
    },
    {
      x: 'Week 9',
      y: 49.35,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 49.425,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 49.45,
      team: 'CAL',
    },
  ],

  'OREGON STATE': [
    {
      x: 'Week 2',
      y: 49.1,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 3',
      y: 49.375,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 4',
      y: 48.8,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 5',
      y: 49.25,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 6',
      y: 49.25,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 7',
      y: 49.425,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 8',
      y: 49.425,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 9',
      y: 49.275,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 10',
      y: 49.475,
      team: 'OREGON STATE',
    },
  ],
  WASHINGTON: [
    { x: 'Week 2', y: 48.675, team: 'WASHINGTON' },
    { x: 'Week 3', y: 48.6, team: 'WASHINGTON' },
    { x: 'Week 4', y: 49.45, team: 'WASHINGTON' },
    { x: 'Week 5', y: 49.15, team: 'WASHINGTON' },
    { x: 'Week 6', y: 47.275, team: 'WASHINGTON' },
    { x: 'Week 7', y: 49.325, team: 'WASHINGTON' },
    { x: 'Week 8', y: 49.2, team: 'WASHINGTON' },
    { x: 'Week 8', y: 48.65, team: 'WASHINGTON' },
    { x: 'Week 9', y: 49.175, team: 'WASHINGTON' },
    { x: 'Week 9', y: 49.3, team: 'WASHINGTON' },
    { x: 'Week 10', y: 49.425, team: 'WASHINGTON' },
  ],
  ARIZONA: [
    { x: 'Week 2', y: 48.7, team: 'ARIZONA' },
    { x: 'Week 3', y: 49.225, team: 'ARIZONA' },
    { x: 'Week 4', y: 48.5, team: 'ARIZONA' },
    { x: 'Week 5', y: 49.175, team: 'ARIZONA' },
    { x: 'Week 6', y: 49.175, team: 'ARIZONA' },
    { x: 'Week 8', y: 49.1, team: 'ARIZONA' },
    { x: 'Week 8', y: 49.275, team: 'ARIZONA' },
    { x: 'Week 9', y: 49, team: 'ARIZONA' },
    { x: 'Week 10', y: 49.125, team: 'ARIZONA' },
    { x: 'Week 10', y: 48.95, team: 'ARIZONA' },
  ],
  'ARIZONA STATE': [
    {
      x: 'Week 2',
      y: 48.925,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 3',
      y: 48.625,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 4',
      y: 49.025,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 5',
      y: 49.1,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 6',
      y: 49.175,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 7',
      y: 49.45,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 8',
      y: 49.175,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 9',
      y: 49.425,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 10',
      y: 49.1,
      team: 'ARIZONA STATE',
    },
  ],

  UCLA: [
    { x: 'Week 3', y: 48.925, team: 'UCLA' },
    { x: 'Week 3', y: 49.275, team: 'UCLA' },
    { x: 'Week 4', y: 49.25, team: 'UCLA' },
    { x: 'Week 5', y: 49.325, team: 'UCLA' },
    { x: 'Week 6', y: 49.325, team: 'UCLA' },
    { x: 'Week 7', y: 48.925, team: 'UCLA' },
    { x: 'Week 8', y: 49.15, team: 'UCLA' },
    { x: 'Week 9', y: 49.625, team: 'UCLA' },
    { x: 'Week 10', y: 49.475, team: 'UCLA' },
  ],

  STANFORD: [
    { x: 'Week 2', y: 49.275, team: 'STANFORD' },
    { x: 'Week 3', y: 49.075, team: 'STANFORD' },
    { x: 'Week 4', y: 48.925, team: 'STANFORD' },
    { x: 'Week 5', y: 49.1, team: 'STANFORD' },
    { x: 'Week 6', y: 48.875, team: 'STANFORD' },
    { x: 'Week 7', y: 48.475, team: 'STANFORD' },
    { x: 'Week 8', y: 49.25, team: 'STANFORD' },
    { x: 'Week 8', y: 47.65, team: 'STANFORD' },
    { x: 'Week 9', y: 49.075, team: 'STANFORD' },
    { x: 'Week 9', y: 49.175, team: 'STANFORD' },
  ],
};

export const floorData = {
  UTAH: [
    {
      x: 'Week 1',
      y: 49.175,
      team: 'UTAH',
    },
    {
      x: 'Week 2',
      y: 49.5,
      team: 'UTAH',
    },
    {
      x: 'Week 3',
      y: 49.675,
      team: 'UTAH',
    },
    {
      x: 'Week 4',
      y: 49.425,
      team: 'UTAH',
    },
    {
      x: 'Week 5',
      y: 49.6,
      team: 'UTAH',
    },
    {
      x: 'Week 6',
      y: 49.525,
      team: 'UTAH',
    },
    {
      x: 'Week 7',
      y: 49.55,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 49.6,
      team: 'UTAH',
    },
    {
      x: 'Week 8',
      y: 49.4,
      team: 'UTAH',
    },
    {
      x: 'Week 9',
      y: 49.675,
      team: 'UTAH',
    },
    {
      x: 'Week 10',
      y: 49.4,
      team: 'UTAH',
    },
  ],
  CAL: [
    {
      x: 'Week 2',
      y: 49.225,
      team: 'CAL',
    },
    {
      x: 'Week 3',
      y: 49.125,
      team: 'CAL',
    },
    {
      x: 'Week 4',
      y: 49.4,
      team: 'CAL',
    },
    {
      x: 'Week 5',
      y: 49.2,
      team: 'CAL',
    },
    {
      x: 'Week 6',
      y: 49.475,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 49.35,
      team: 'CAL',
    },
    {
      x: 'Week 8',
      y: 49.425,
      team: 'CAL',
    },
    {
      x: 'Week 9',
      y: 49.25,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 49.325,
      team: 'CAL',
    },
    {
      x: 'Week 10',
      y: 49.6,
      team: 'CAL',
    },
  ],

  'OREGON STATE': [
    {
      x: 'Week 2',
      y: 49.275,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 3',
      y: 49.45,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 4',
      y: 49.225,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 5',
      y: 49.5,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 6',
      y: 49.675,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 7',
      y: 49.4,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 8',
      y: 49.575,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 9',
      y: 49.075,
      team: 'OREGON STATE',
    },
    {
      x: 'Week 10',
      y: 49.075,
      team: 'OREGON STATE',
    },
  ],
  WASHINGTON: [
    { x: 'Week 2', y: 47.625, team: 'WASHINGTON' },
    { x: 'Week 3', y: 49.125, team: 'WASHINGTON' },
    { x: 'Week 4', y: 47.875, team: 'WASHINGTON' },
    { x: 'Week 5', y: 49.125, team: 'WASHINGTON' },
    { x: 'Week 6', y: 49, team: 'WASHINGTON' },
    { x: 'Week 7', y: 49.075, team: 'WASHINGTON' },
    { x: 'Week 8', y: 49.425, team: 'WASHINGTON' },
    { x: 'Week 8', y: 48.8, team: 'WASHINGTON' },
    { x: 'Week 9', y: 49.05, team: 'WASHINGTON' },
    { x: 'Week 9', y: 49.225, team: 'WASHINGTON' },
    { x: 'Week 10', y: 49.275, team: 'WASHINGTON' },
  ],
  ARIZONA: [
    { x: 'Week 2', y: 48.825, team: 'ARIZONA' },
    { x: 'Week 3', y: 48.9, team: 'ARIZONA' },
    { x: 'Week 4', y: 49.05, team: 'ARIZONA' },
    { x: 'Week 5', y: 49.1, team: 'ARIZONA' },
    { x: 'Week 6', y: 49.35, team: 'ARIZONA' },
    { x: 'Week 8', y: 49.25, team: 'ARIZONA' },
    { x: 'Week 8', y: 49.3, team: 'ARIZONA' },
    { x: 'Week 9', y: 49.425, team: 'ARIZONA' },
    { x: 'Week 10', y: 49.1, team: 'ARIZONA' },
    { x: 'Week 10', y: 49.325, team: 'ARIZONA' },
  ],
  'ARIZONA STATE': [
    { x: 'Week 2', y: 49.05, team: 'ARIZONA STATE' },
    {
      x: 'Week 3',
      y: 49.075,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 4',
      y: 48.975,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 5',
      y: 49.025,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 6',
      y: 48.95,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 7',
      y: 49.525,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 8',
      y: 49.325,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 9',
      y: 49.4,
      team: 'ARIZONA STATE',
    },
    {
      x: 'Week 10',
      y: 49.1,
      team: 'ARIZONA STATE',
    },
  ],

  UCLA: [
    { x: 'Week 3', y: 49.125, team: 'UCLA' },
    { x: 'Week 3', y: 49, team: 'UCLA' },
    { x: 'Week 4', y: 48.85, team: 'UCLA' },
    { x: 'Week 5', y: 49.6, team: 'UCLA' },
    { x: 'Week 6', y: 49.025, team: 'UCLA' },
    { x: 'Week 7', y: 49.4, team: 'UCLA' },
    { x: 'Week 8', y: 49.55, team: 'UCLA' },
    { x: 'Week 9', y: 49.775, team: 'UCLA' },
    { x: 'Week 10', y: 49.325, team: 'UCLA' },
  ],

  STANFORD: [
    { x: 'Week 2', y: 49.075, team: 'STANFORD' },
    { x: 'Week 3', y: 48.85, team: 'STANFORD' },
    { x: 'Week 4', y: 49.175, team: 'STANFORD' },
    { x: 'Week 5', y: 49.3, team: 'STANFORD' },
    { x: 'Week 6', y: 49.6, team: 'STANFORD' },
    { x: 'Week 7', y: 49.325, team: 'STANFORD' },
    { x: 'Week 8', y: 49.475, team: 'STANFORD' },
    { x: 'Week 8', y: 49.275, team: 'STANFORD' },
    { x: 'Week 9', y: 49.575, team: 'STANFORD' },
    { x: 'Week 9', y: 49.15, team: 'STANFORD' },
  ],
};
